// extracted by mini-css-extract-plugin
export default {"scrollContainer":"table_scrollContainer__O3VyK"};